import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import { useFormik } from "formik"
import * as yup from "yup"
import { getCurrentISODate } from "../../../utils"

const CopyDialog = ({
    open, onClose, onSave,
}) => {

    const { values, handleChange, handleSubmit, errors, touched } = useFormik({
        initialValues: {
            start_date: getCurrentISODate(),
            end_date: getCurrentISODate(),
            weeks_count: 1,
        },
        enableReinitialize: true,
        validationSchema: yup.object({
            start_date: yup.date().required(),
            end_date: yup.date().required(),
            weeks_count: yup.number().required().min(0)
        }),
        onSubmit: onSave
    })

    return <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">

        <DialogTitle>
            Копирование занятий
        </DialogTitle>

        <DialogContent>

            <TextField
                id="start_date"
                name="start_date"
                label="Начало периода"
                value={values.start_date}
                onChange={handleChange}
                type="date"
                error={touched.start_date && Boolean(errors.start_date)}
                required
                fullWidth
                slotProps={{ inputLabel: { shrink: true } }}
            />
            <TextField
                id="end_date"
                name="end_date"
                label="Конец периода"
                value={values.end_date}
                onChange={handleChange}
                type="date"
                error={touched.end_date && Boolean(errors.end_date)}
                required
                fullWidth
                slotProps={{ inputLabel: { shrink: true } }}
            />

            <TextField
                id="weeks_count"
                name="weeks_count"
                label="На сколько недель скопировать"
                value={values.weeks_count}
                onChange={handleChange}
                type="number"
                error={touched.weeks_count && Boolean(errors.weeks_count)}
                required
                fullWidth
            />
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSubmit}>
                Скопировать занятия
            </Button>
            <Button onClick={onClose} color="error">
                Закрыть
            </Button>
        </DialogActions>

    </Dialog>
}

export default CopyDialog